// libraries.
import { ZoomIn, ZoomOut } from 'lucide-react';

interface ImgZoomButtonsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export const ImgZoomButtons = ({
  onZoomIn,
  onZoomOut,
}: ImgZoomButtonsProps) => {
  return (
    <>
      <button
        type="button"
        onClick={onZoomOut}
        className="btn btn-light border-0 py-1 px-2"
      >
        <ZoomOut size={18} />
      </button>
      <button
        type="button"
        onClick={onZoomIn}
        className="btn btn-light border-0 py-1 px-2"
      >
        <ZoomIn size={18} />
      </button>
    </>
  );
};
